export default class Api {
  static async getAddress(zipcode) {
    const response = await fetch(`https://madefor.github.io/postal-code-api/api/v1/${zipcode.slice(0, 3)}/${zipcode.slice(-4)}.json`, {
      mode: 'cors',
    });
    if (response.status === 404) {
      return {
        error: `郵便番号: ${zipcode}で住所が見つかりませんでした。`,
      };
    }
    return await response.json();
  }
}
